module.exports = __webpack_public_path__ + "img/sample1.e0278386.jpg";